
export default {
  name: 'GlobalNotificationBar',
  data() {
    return {
      show: true,
    }
  },
}
